import { getProducts } from "@/api/metadata";

const fuelsType = {
  namespaced: true,
  state: {
    fuels: [],
  },
  actions: {
    getFuelsList({ commit }) {
      getProducts().then((fuels) => {
        commit("FETCH_FUELS_LIST", fuels);
      });
    },
    isBlendedProduct({ rootGetters }, payload) {
      const blendedProductConfig = rootGetters["metadata/blendedProductConfig"];
      return blendedProductConfig.includes(payload);
    },
  },
  mutations: {
    FETCH_FUELS_LIST: (state, payload) => {
      state.fuels = payload;
    },
  },
  getters: {
    getFuelsType: (state) => {
      return state.fuels;
    },
    getSpotFuels: (state) => {
      const fuels = state.fuels.filter((product) => product.type === "SPOT");
      return fuels;
    },
  },
};

export default fuelsType;
